/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getArrayDecoder,
  getArrayEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from '@solana/kit';
import {
  getVestingAllocationInputDecoder,
  getVestingAllocationInputEncoder,
  getVestingScheduleDecoder,
  getVestingScheduleEncoder,
  type VestingAllocationInput,
  type VestingAllocationInputArgs,
  type VestingSchedule,
  type VestingScheduleArgs,
} from '.';

export type InitializeVestingArgs = {
  initialSupply: bigint;
  schedules: Array<VestingSchedule>;
  allocations: Array<VestingAllocationInput>;
};

export type InitializeVestingArgsArgs = {
  initialSupply: number | bigint;
  schedules: Array<VestingScheduleArgs>;
  allocations: Array<VestingAllocationInputArgs>;
};

export function getInitializeVestingArgsEncoder(): Encoder<InitializeVestingArgsArgs> {
  return getStructEncoder([
    ['initialSupply', getU64Encoder()],
    ['schedules', getArrayEncoder(getVestingScheduleEncoder())],
    ['allocations', getArrayEncoder(getVestingAllocationInputEncoder())],
  ]);
}

export function getInitializeVestingArgsDecoder(): Decoder<InitializeVestingArgs> {
  return getStructDecoder([
    ['initialSupply', getU64Decoder()],
    ['schedules', getArrayDecoder(getVestingScheduleDecoder())],
    ['allocations', getArrayDecoder(getVestingAllocationInputDecoder())],
  ]);
}

export function getInitializeVestingArgsCodec(): Codec<
  InitializeVestingArgsArgs,
  InitializeVestingArgs
> {
  return combineCodec(
    getInitializeVestingArgsEncoder(),
    getInitializeVestingArgsDecoder(),
  );
}
